<template>
    <div>
        <footer>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p><i class="fa fa-copyright"></i> Copyright 2024 by SMP Lab Malang</p>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'app',
    data() {
        return {

        }
    }
}
</script>